import * as React from "react";
import * as _ from "lodash";
import {IAppointmentScheduleResponse} from "@curefit/care-common";
import AppLoader from "../../utils/AppLoader";
import {default as AppUtils, LOADING_STATE} from "../../../utils/AppUtils";
import CollapsibleCardView from "../../CollapsibleCardView";
import CollapsiblePanel from "../../CollapsiblePanel";
import CustomHeader, {ICustomHeaderInfo} from "../../utils/CustomHeader";
import {PatientPrescription} from "../PatientConsultationSummary"
import {ConsultationStatusConstant} from "../../../utils/AppConstants";
import IMedicineType from "../../../models/staticData/IMedicineType";
/*
 * Created by Prachi on 21/03/18.
 * Patient past illnesses view component
 */
interface ConsultationProps {
    consultation: IAppointmentScheduleResponse;
    fetchPastConsultationData: (consultationId: string, doctorType: string, patientId: string) => Promise<any>,
    staticMedicineTypes: IMedicineType[]
}
interface ConsultationStates {
    isLoading: boolean
}
export class Consultation extends React.Component<ConsultationProps, ConsultationStates> {

    constructor(props: ConsultationProps) {
        super(props);
        this.state = {
            isLoading: false
        }
    }

    handlePanelClick = () => {
        if(!this.props.consultation.consultationData) {
            this.setState({isLoading: true}, () => {
                this.props.fetchPastConsultationData(this.props.consultation.id.toString(), this.props.consultation.doctorType, this.props.consultation.patient.id.toString()).then(() => {
                    this.setState({isLoading: false})
                }).catch(() => {
                    this.setState({isLoading: false})
                })
            })
        }
    }

    render() {
        let {consultation} = this.props;
        let consultationDate = consultation && AppUtils.getDayEpochInfo(consultation.startTime);
        let showPrescription = consultation && !_.isEmpty(consultation.consultationData);
        let showComplaints = showPrescription && consultation.consultationData.chiefComplaints && !_.isEmpty(consultation.consultationData.chiefComplaints.patientComplaints);
        let showDiagnosis = showPrescription && consultation.consultationData.prescriptionDiagnosis && !_.isEmpty(consultation.consultationData.prescriptionDiagnosis.diagnosticsList);
        return <CollapsiblePanel handleClick={this.handlePanelClick}>
            <div className="consultation-header">
                <div className="in-blk past-illnesses-icon">
                    <img src={AppUtils.getConsultationTypeImageUrl(consultation)} />
                </div>
                <div className="in-blk past-illnesses-date">
                    {consultationDate.dateText} {consultationDate.month}, {consultationDate.year}
                </div>
                <div className="in-blk past-illnesses-complaints">
                    {showComplaints && consultation.consultationData.chiefComplaints.patientComplaints.map((symptom: any, index: number) => {
                        return <span key={index}>
                            {symptom.complaint.displayValue}
                            {index !== consultation.consultationData.chiefComplaints.patientComplaints.length - 1 && <span>, &nbsp;</span>}
                        </span>
                    })}
                </div>
                <div className="in-blk past-illnesses-diagnosis">
                    {showDiagnosis && consultation.consultationData.prescriptionDiagnosis.diagnosticsList.map((diagnosis: any, index: number) => {
                        return <span key={index}>
                            {diagnosis.disease.displayValue}
                            {index !== consultation.consultationData.prescriptionDiagnosis.diagnosticsList.length - 1 && <span>, &nbsp;</span>}
                        </span>
                    })}
                </div>
                <div className="consultation-label">
                    Prescription
                </div>
            </div>
            <div className="patient-consultation-summary-container">
                {this.state.isLoading && <div><AppLoader/></div>}
                {!this.state.isLoading && <PatientPrescription prescription={consultation.consultationData} caseSummary={consultation.caseSummary} staticMedicineTypes={this.props.staticMedicineTypes}/>}
            </div>
        </CollapsiblePanel>
    }
}
interface PatientPastIllnessesProps {
    pastConsultations: IAppointmentScheduleResponse[],
    fetchPastConsultationData: (consultationId: string, doctorType: string, patientId: string) => Promise<any>,
    staticMedicineTypes: IMedicineType[]
}
interface PatientPastIllnessesStates {
    isPastIllnessesLoaded: LOADING_STATE;
}
export default class PatientPastIllnesses extends React.Component<PatientPastIllnessesProps, PatientPastIllnessesStates> {
    constructor(props: PatientPastIllnessesProps) {
        super(props);
        this.state = {isPastIllnessesLoaded: LOADING_STATE.LOADED}
    }
    render() {
        let isLoaded = LOADING_STATE.LOADED === this.state.isPastIllnessesLoaded;
        let {pastConsultations} = this.props;
        pastConsultations = _.orderBy(pastConsultations, ["startTime"], ["desc"]);
        let pastIllnessHeaderInfos: ICustomHeaderInfo[] = [
            {label: "icon", display: ""},
            {label: "date", display: "DATE"},
            {label: "complaints", display: "CHIEF COMPLAINTS"},
            {label: "diagnosis", display: "DIAGNOSIS"},
        ];
        return(<div className="patient-past-illnesses-container">
            {isLoaded && <CollapsibleCardView titleComponent={"Past Consultations"}>
                <div>
                    <CustomHeader headerInfos={pastIllnessHeaderInfos} rootCls={"past-illnesses"}/>
                    {!_.isEmpty(pastConsultations) && _.map(pastConsultations, (consultation, index: number) => {
                        if (consultation.status === ConsultationStatusConstant.COMPLETED) {
                            return <div key={index} className="past-consultation-container">
                                <Consultation consultation={consultation} fetchPastConsultationData={this.props.fetchPastConsultationData} staticMedicineTypes={this.props.staticMedicineTypes}/>
                            </div>
                        }
                    })}
                </div>
            </CollapsibleCardView>}
            {!isLoaded && <AppLoader/>}
        </div>);
    }
}